import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Star } from 'lucide-react';
import { ROUTES, IMAGES } from '../utils/constants';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="logo">
          <img src={IMAGES.logo} alt="Little Star Logo" className="logo-img" />
          <span className="logo-text">Little Star</span>
        </Link>

        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          {ROUTES.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.name}
            </Link>
          ))}
          <Link to="/contact" className="btn btn-primary nav-btn">Enroll Now</Link>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      <style>{`
        .navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          background-color: transparent;
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
          padding: 1.5rem 0;
        }
        
        .navbar.scrolled {
          background-color: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          box-shadow: var(--shadow-sm);
          padding: 1rem 0;
        }
        
        .navbar-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-family: var(--font-heading);
          font-weight: 800;
          font-size: 1.5rem;
          color: var(--color-text-main);
          letter-spacing: -0.02em;
        }
        
        .logo-img {
          height: 65px; /* Increased from 50px */
          width: auto;
          /* Optional: if logo needs specific styling */
        }
        
        .nav-links {
          display: flex;
          align-items: center;
          gap: 2rem;
        }
        
        .nav-link {
          font-weight: 500;
          color: var(--color-text-light);
          position: relative;
        }
        
        .nav-link:hover, .nav-link.active {
          color: var(--color-primary);
        }
        
        .nav-link.active::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: var(--color-secondary);
          border-radius: 2px;
        }
        
        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: var(--color-text-main);
          cursor: pointer;
        }

        @media (max-width: 768px) {
          .mobile-menu-btn {
            display: block;
          }
          
          .nav-links {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background-color: white;
            flex-direction: column;
            padding: 2rem;
            box-shadow: var(--shadow-lg);
            clip-path: circle(0% at 100% 0);
            transition: clip-path 0.4s ease-in-out;
            pointer-events: none;
          }
          
          .nav-links.active {
            clip-path: circle(150% at 100% 0);
            pointer-events: all;
          }
          
          .nav-btn {
            width: 100%;
            margin-top: 1rem;
          }
        }
      `}</style>
    </nav>
  );
};

export default Header;